/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_TitleInputs */

const en_case_title = /** @type {(inputs: Case_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Case`)
};

const pt_br2_case_title = /** @type {(inputs: Case_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caso`)
};

/**
* | output |
* | --- |
* | "Case" |
*
* @param {Case_TitleInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_title = /** @type {((inputs?: Case_TitleInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_TitleInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_title(inputs)
	return pt_br2_case_title(inputs)
});